import type { CompanyIndustryAttributes, CompanyIndustryProfile } from '@/types/company'

const toValues = (value: unknown): string[] => {
  const list = Array.isArray(value) ? value : value == null || value === '' ? [] : [value]
  return list.map((item) => String(item).trim()).filter((item) => item !== '')
}

/**
 * Client-side mirror of CompanyIndustryProfiles::validateAttributes().
 * Returns error messages keyed by field key.
 */
export const industryAttributeErrors = (
  profile: CompanyIndustryProfile | null,
  attributes: CompanyIndustryAttributes | null | undefined
): Record<string, string> => {
  const errors: Record<string, string> = {}
  if (!profile) return errors

  for (const field of profile.fields) {
    const values = toValues(attributes?.[field.key])
    const allowed = field.options.map((option) => option.value)

    if (values.some((value) => !allowed.includes(value))) {
      errors[field.key] = `Invalid ${field.label} value`
    } else if (field.type === 'select' && values.length > 1) {
      errors[field.key] = `Select only one ${field.label}`
    } else if (field.required && values.length === 0) {
      errors[field.key] = field.required_message ?? `${field.label} is required`
    }
  }

  return errors
}

export const hasIndustryAttributeValue = (
  attributes: CompanyIndustryAttributes | null | undefined,
  key: string
): boolean => toValues(attributes?.[key]).length > 0
